import React, { useRef } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import { useTrans, useFeatureFlags } from "../../hooks";
import { ConnectImage, Icon, Modal, MODAL_ID } from "../../shared-components";
import { Button, ButtonVariant, Typography } from "@wattpad/web-ui-library";

const PremiumPicksFAQModal = ({ showModal, onClose }) => {
  const modalRef = useRef();
  const { trans } = useTrans();
  const featureflags = useFeatureFlags();

  const handleClose = () => {
    onClose();
    modalRef.current.hide();
  };

  const checkIcon = (
    <div className="check-icon-container">
      <Icon
        name="check"
        size="24"
        viewBox="24"
        color="ds-neutral-100"
        className="check-icon"
        fill={true}
        strokeWidth="0"
      />
    </div>
  );

  return (
    <Modal
      id={MODAL_ID.PREMIUM_PICKS_FAQ_MODAL_ID}
      {...{ showModal, onClose }}
      ref={modalRef}
    >
      <div className="premium-picks-faq-content">
        <div className="premium-picks-faq-header">
          <h2 className={classnames("modal-title", Typography.HEADING.XSMALL)}>
            {trans("Premium Picks")}
          </h2>
          {featureflags.ROTATING_CATALOG_PHASE_3 ? (
            <ConnectImage
              className="premium-picks-image"
              name={`library/premium-picks-fresh-books.png`}
              title={trans("Stack of freshly cooked books")}
            />
          ) : (
            <ConnectImage
              className="premium-picks-image"
              name={`library/premium-picks-banner-books.png`}
              title={trans("Stack of books")}
            />
          )}
        </div>

        <ul
          className={classnames(
            "premium-picks-faq-features",
            Typography.PARAGRAPH.MEDIUM
          )}
        >
          <li>
            {checkIcon}

            {featureflags.ROTATING_CATALOG_PHASE_3
              ? trans(
                  "Wattpad Premium and Premium+ subscribers get a free monthly bundle of 5+ Wattpad Originals."
                )
              : trans(
                  "Subscribers get a free monthly bundle of 5 Wattpad Originals."
                )}
          </li>
          <li>
            {checkIcon}
            {featureflags.ROTATING_CATALOG_PHASE_3
              ? trans(
                  "Premium Picks refresh on the first day of each month. Read for free all month without paywalls."
                )
              : trans("Premium Picks refresh on the first day of each month.")}
          </li>
          <li>
            {checkIcon}
            {featureflags.ROTATING_CATALOG_PHASE_3
              ? trans(
                  "Explore new genres, writers, and quality reads every month."
                )
              : trans(
                  "Indulge in quality reads, no ads, unlimited offline reading, and more, for the same great price."
                )}
          </li>
        </ul>
      </div>
      <div className="premium-picks-faq-footer">
        <Button onClick={handleClose} label={trans("Got it")} />

        <Button
          href="https://support.wattpad.com/hc/en-us/articles/18722782071956-Premium-Picks-"
          variant={ButtonVariant.TERTIARY}
          label={
            featureflags.ROTATING_CATALOG_PHASE_3
              ? trans("Premium Picks FAQ")
              : trans("Additional FAQs")
          }
        />
      </div>
    </Modal>
  );
};

PremiumPicksFAQModal.propTypes = {
  showModal: PropTypes.bool,
  onClose: PropTypes.func
};

export default PremiumPicksFAQModal;
